import api from "../../Services/api";
import React, { useEffect, useState } from "react";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import GridRegistros from "../../Componentes/GridRegistros";
import { Modal } from "react-bootstrap";
import "./index.css";

const AprovarOperadoresExternos = () => {
  const [operadoresExternos, setOperadoresExternos] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [operadorSelecionado, setOperadorSelecionado] = useState(null);
  const [cargoSelecionado, setCargoSelecionado] = useState("");
  const [processos, setProcessos] = useState([]);
  const [cliente, setcliente] = useState('');
  const [processosSelecionados, setProcessosSelecionados] = useState([]);

  const { authReady } = useAuthContext();
  const { IDOperador, nome: nomeOperador, operador } = useOperador();
  const navigate = useNavigate();

  let idFormatado = String(IDOperador).padStart(6, "0");

  useEffect(() => {
    if (!operador) {
      navigate("/");
    }
    carregarOperadoresExternos();
    carregarCargos();
  }, [operador]);

  const carregarOperadoresExternos = async () => {
    try {
      const res = await api.get("/cadOperadorExterno/GetAll");
      setOperadoresExternos(res.data);
    } catch (err) {
      setOperadoresExternos([]);
      console.error("Erro ao carregar operadores externos", err);
    }
  };

  const carregarCargos = async () => {
    try {
      const res = await api.get("/cargos");
      setCargos(res.data);
    } catch (err) {
      console.error("Erro ao carregar cargos", err);
    }
  };

  const abrirModal = async (operador) => {
    setOperadorSelecionado(operador);
    setCargoSelecionado("");

    if (operador.IDCliente) {
    
      const cliente = await carregarCliente(operador.IDCliente);
      if (cliente) {
        setcliente(cliente.Cliente.nome + " - CNPJ: "+ cliente.Cliente.cnpj); 
      }

      await carregarProcessos(operador.IDCliente);
    }

    setShowModal(true);
  };


  const carregarProcessos = async (idcliente) => {
    try {
      const res = await api.get(`/processo/cliente/${idcliente}`);
      const listaProcessos = res.data;

      let idsVinculados = [];
      if (operadorSelecionado?.IDOperadorexterno) {
        const resVinculados = await api.get(`/processo/operadorcliente/${operadorSelecionado.IDOperadorexterno}/${idcliente}`);
        idsVinculados = resVinculados.data.map(p => p.IDProcesso);
      }

      setProcessos(listaProcessos);
      setProcessosSelecionados(idsVinculados);
    } catch (err) {
      console.error("Erro ao carregar processos", err);
    }
  };


  const handleProcessoChange = (processoId) => {
    setProcessosSelecionados((prev) =>
      prev.includes(processoId)
        ? prev.filter((id) => id !== processoId)
        : [...prev, processoId]
    );
  };

  const carregarCliente = async (idCliente) => {
    try {
      const res = await api.get(`/cliente/${idCliente}`);
      return res.data; // assume que retorna o objeto cliente completo
    } catch (err) {
      console.error("Erro ao buscar cliente", err);
      return null;
    }
  };

  const formatarDataISO = (date) => {
    const ano = date.getFullYear();
    const mes = String(date.getMonth() + 1).padStart(2, "0");
    const dia = String(date.getDate()).padStart(2, "0");
    const horas = String(date.getHours()).padStart(2, "0");
    const minutos = String(date.getMinutes()).padStart(2, "0");
    const segundos = String(date.getSeconds()).padStart(2, "0");

    // Usa "T" para ser válido no Node/Yup
    return `${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos}`;
  };

  const handleAprovar = async () => {
    if (!cargoSelecionado) {
      Swal.fire("Atenção", "Selecione um cargo antes de aprovar.", "warning");
      return;
    }
    
    const result = await Swal.fire({
      title: "Tem certeza?",
      text: "Você deseja aprovar este operador?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sim, aprovar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "var(--color-btnCancelar-danger)",
      customClass: {
        cancelButton: "swal-cancel-danger",
      },
    });

    if (!result.isConfirmed) return;

    try {
      // Criar operador
      const formatDate = (date) => date.toISOString().split("T")[0];

      const body = {
        nome: operadorSelecionado.nome,
        cpf: operadorSelecionado.cpf.replace(/\D/g, ""), // tira máscara se tiver
        email: operadorSelecionado.email,
        senha: operadorSelecionado.senha,
        dataCadastro: new Date().toISOString().slice(0, 19).replace("T", " "),
        dataExpiracao: new Date().toISOString().slice(0, 19).replace("T", " "),
        situacao: 1 // ativo
      };

      const resOperador = await api.post("/operador", body);
      const IDOperadorCriado = resOperador.data.IDOperador;

      // Atualizar situação no cadastro externo
      await api.put(`/cadOperadorExterno/${operadorSelecionado.IDOperadorexterno}`, {
        ...operadorSelecionado,
        dataCadastro: new Date().toISOString().slice(0, 19).replace("T", " "),
        dataExpiracao: new Date().toISOString().slice(0, 19).replace("T", " "),
        situacao: 1,
      });

      // Vincular cargo
      await api.post("/operadorcargo", {
        IDOperador: IDOperadorCriado,
        IDCargo: cargoSelecionado,
      });

      // Limpar vínculos antigos (se existir)
      await api.delete(`/processo/operadorcliente/${IDOperadorCriado}/${operadorSelecionado.IDCliente}`);

      // Inserir vínculos novos
      for (const idProcesso of processosSelecionados) {
        await api.post("/processo/operador", {
          IDOperador: IDOperadorCriado,
          IDProcesso: idProcesso,
        });
      }

      Swal.fire("Sucesso", "Operador aprovado com sucesso!", "success");
      setOperadorSelecionado(null);
      setShowModal(false);
      await carregarOperadoresExternos();
      setShowModal(false);
    } catch (err) {
      console.error("Erro ao aprovar operador externo", err);
      const mensagem =
        err.response?.data?.errors?.default ||
        err.response?.data?.message ||
        "Falha ao aprovar operador.";
      const cpfJaCadastrado =
        err.response?.status === 409 && mensagem.toUpperCase().includes("CPF");

      Swal.fire(
        cpfJaCadastrado ? "CPF ja cadastrado" : "Erro",
        mensagem,
        cpfJaCadastrado ? "warning" : "error",
      );
    }
  };


  const handleRecusar = async (operador) => {

    const result = await Swal.fire({
      title: "Tem certeza?",
      text: "Você deseja recusar este operador?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, recusar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "var(--color-btnCancelar-danger)",
      customClass: {
        cancelButton: "swal-cancel-danger",
      },
    });
    if (!result.isConfirmed) return;

    try {
      await api.put(`/cadOperadorExterno/${operador.IDOperadorexterno}`, {
        ...operador,
        situacao: 2,
      });

      Swal.fire("Recusado", "Operador recusado com sucesso!", "info");
      carregarOperadoresExternos();
      setShowModal(false);
    } catch (err) {
      console.error("Erro ao recusar operador externo", err);
      Swal.fire("Erro", "Falha ao recusar operador - " + err, "error");
    }
  };

  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior userId={idFormatado} userName={nomeOperador} />
        <h4 style={{ width: "100%", textAlign: "center", paddingTop: "50px" }}>
          APROVAÇÃO DE OPERADORES EXTERNOS
        </h4>

        <div style={{ width: "100%", alignItems: "center", paddingTop: "50px" }}>
          <GridRegistros
            registros={operadoresExternos}
            chaveId="IDOperadorexterno"
            exibirEditar={true}
            exibirDeletar={false}
            ocultarCampos={["senha", "situacao", "IDCliente", "codigovalida"]}
            onEdit={abrirModal} 
          />
        </div>

        {/* Modal de aprovação/recusa */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Aprovar Operador</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {operadorSelecionado && (
              <div>
                <p><b>Nome:</b> {operadorSelecionado.nome}</p>
                <p><b>Email:</b> {operadorSelecionado.email}</p>
                <p><b>CPF:</b> {operadorSelecionado.cpf}</p>
                <p><b>Cliente:</b> {cliente}</p>

                <div className="form-group mt-3">
                  <label><b>Cargo</b></label>
                  <select
                    className="form-control"
                    value={cargoSelecionado}
                    onChange={(e) => setCargoSelecionado(e.target.value)}
                  >
                    <option value="">Selecione Cargo</option>
                    {cargos.map((cargo) => (
                      <option key={cargo.IDCargo} value={cargo.IDCargo}>
                        {cargo.Descrição}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Lista de processos */}
                <div className="mt-4">
                  <h5>Processos</h5>
                  <ul style={{ maxHeight: "200px", overflowY: "auto" }}>
                    {processos.map((p) => (
                      <li key={p.IDProcesso}>
                        <label>
                          <input
                            type="checkbox"
                            checked={processosSelecionados.includes(p.IDProcesso)}
                            onChange={() => handleProcessoChange(p.IDProcesso)}
                          />
                          {p.descricao}
                        </label>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </Modal.Body>

          <Modal.Footer>
            <div style={{ display: "flex", gap: "10px", justifyContent: "center", width: "100%" }}>
              <button className="btn btn-success" onClick={handleAprovar}>
                Aprovar
              </button>
              <button
                className="btn btn-danger"
                onClick={() => {
                  handleRecusar(operadorSelecionado);
                }}
              >
                Recusar
              </button>
            </div>
          </Modal.Footer>

        </Modal>
      </div>
    </div>
  );
};

export default AprovarOperadoresExternos;
